import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import queryScheduleResult from '../../QueryResult/useScheduleResult'
import validate from './validation'
export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation (
        $lessonInput: EditLessonInputFromAdmin!
        $lessonId: String!
        $noDateChanges: Boolean
    ) {
          editLessonFromAdmin(
            lessonInput: $lessonInput
            lessonId: $lessonId
            noDateChanges: $noDateChanges
          ){
            ${queryScheduleResult}
        }
    }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submitRaw = useCallback(async (obj) => {
    const errors = validate(obj)
    if (errors && Object.keys(errors).length) {
      setValidationErrors(errors)
      throw new Error('validation Error')
    }
    try {
      return await mutation({ variables: obj })
    } catch (e) {
      setValidationErrors({ general: 'misc.apiError' })
      throw e
    }
  }, [mutation])
  const submit = useCallback((obj) => {
    return submitRaw(obj).then((result) => {
      onSuccess(result)
      return result
    }).catch((e) => {
      onError(e)
      return null
    })
  }, [submitRaw, onSuccess, onError])
  return { loading, data: data ? data.editLessonFromAdmin : null, error, validationErrors, submit, submitRaw }
}
